import { Route } from 'react-router';
import { Redirect, Switch, useParams } from 'react-router-dom';
import { userHasTasksEnabledRedir } from '../core/auth';
import Tasks from '../views/tasks/containers/Tasks';
import TodaysTasksNew from '../views/tasks/containers/TodaysTasksNew';
import WorkOrders from '../views/tasks/WorkOrders';
import { useFeatureFlag } from '../core/hooks/useFeatureFlag';
import { usePermissionCheck } from '../core/hooks/usePermissionCheck';
import { viewPermissionRefs } from '../core/components/UserGroupPermissions';
import TodaysTasks from '../views/tasks/containers/TodaysTasks';
import MaintenanceTasksIndex from '../views/tasks/Maintenance/index';

const TasksRoute = () => {
  const { site } = useParams();
  const hasPermission = usePermissionCheck(viewPermissionRefs.todays_tasks_new);
  const taskDetailsV2Enabled = useFeatureFlag('task-details-v2', false);
  return (
    <div className="container-fluid">
      <div className="page-main-content">
        <Switch>
          <Route path="/:site/tasks" exact={true}>
            {hasPermission ? (
              <TodaysTasksNew />
            ) : (
              <TodaysTasks taskDetailsV2Enabled={taskDetailsV2Enabled} />
            )}
          </Route>
          <Route path="/:site/tasks/maintenance">
            {/* <MaintenanceTaskOld /> */}
            <MaintenanceTasksIndex />
          </Route>
          <Route path="/:site/tasks/projects">
            <Redirect to={`/${site || ''}/tasks/work-orders`} />
          </Route>
          <Route path="/:site/tasks/work-orders">
            {/* {hasProjectsPermission ? <WorkOrderPage /> : <Redirect to={`/${site || ''}/tasks`} />} */}
            <WorkOrders />
          </Route>
          <Route path="/:site/tasks/admin">
            <Tasks />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default userHasTasksEnabledRedir(TasksRoute);
